var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClapping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 243,
    viewBox: "0 0 216 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.769 79.3125C214.026 74.0423 211.555 69.1659 207.743 65.4442C203.931 61.7225 198.991 59.3648 193.695 58.7391L186.627 57.9357L192.125 44.279C193.894 39.8975 194.333 35.0939 193.388 30.4653C192.443 25.8367 190.156 21.5872 186.812 18.2449C183.467 14.9027 179.212 12.6151 174.575 11.6663C169.938 10.7176 165.124 11.1497 160.731 12.9088L149.22 17.5119C147.817 13.2904 145.27 9.53868 141.862 6.67225C138.454 3.80582 134.318 1.93648 129.912 1.27116C125.505 0.605841 120.999 1.17052 116.894 2.90266C112.789 4.63481 109.245 7.46686 106.653 11.0853L97.1302 24.3644C96.5667 24.4769 96.0031 24.6054 95.4477 24.758C94.6427 24.5572 93.8377 24.3805 92.9844 24.2439C87.728 23.3683 74.3492 22.83 63.5867 36.6875C60.2702 40.9452 57.8795 45.709 55.7624 49.9185L55.4002 50.6254C49.3146 49.464 43.0162 50.2746 37.425 52.939C31.1865 55.9354 22.9919 62.579 19.4098 77.2479C17.4295 85.3616 16.3266 87.6913 16.1174 88.109C15.9886 88.2857 15.6828 88.6713 15.4494 88.9686C12.3985 92.8165 9.10616 97.3634 5.39523 106.811C-0.698437 122.331 0.291549 136.871 3.84954 147.419C2.98822 164.169 9.4362 178.315 16.4636 187.907L15.7793 216.651C15.702 219.864 16.2695 223.06 17.4484 226.051C18.6274 229.042 20.394 231.767 22.6442 234.067C24.8944 236.367 27.5829 238.194 30.5513 239.441C33.5196 240.688 36.7079 241.33 39.9286 241.329H106.347C112.752 241.329 118.894 238.79 123.423 234.27C127.952 229.751 130.496 223.621 130.496 217.229V183.658L138.796 160.224L139.013 160.321C141.955 161.524 145.107 162.135 148.286 162.12C151.466 162.104 154.611 161.462 157.541 160.231C160.472 158.999 163.129 157.202 165.362 154.943C167.595 152.684 169.359 150.007 170.552 147.066L175.317 147.869C180.096 148.715 185.019 148.104 189.445 146.116C193.871 144.129 197.594 140.856 200.128 136.726C202.663 132.596 203.892 127.799 203.655 122.961C203.417 118.124 201.725 113.47 198.799 109.606L196.384 106.457L200.215 104.85C205.123 102.79 209.21 99.1691 211.843 94.5506C214.475 89.932 215.503 84.5749 214.769 79.3125Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.184 101.951C120.184 101.951 124.209 92.8329 129.281 95.3714C135.64 98.5446 131.551 108.305 131.551 108.305L106.347 179.521V217.173H39.9767L40.8862 179.071C40.8862 179.071 24.5211 165.005 28.6184 143.684C32.7157 122.363 39.9766 118.283 43.1643 110.571C46.352 102.859 44.5247 95.5964 47.7043 89.6838C50.884 83.7713 55.4321 85.6029 58.169 91.0495C60.9059 96.4961 57.7183 114.635 55.4402 121.44C53.1621 128.244 47.7124 140.945 47.7124 140.945",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5957 111.928C58.5957 111.928 77.231 81.0801 82.2299 73.826C87.2288 66.5719 90.4165 63.3826 94.9566 64.2984C99.4966 65.2142 101.098 70.1949 96.325 79.2645C91.7688 87.9165 76.3213 116.017 76.3213 116.017",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3254 79.2643C96.3254 79.2643 103.369 63.8403 110.412 66.7965C117.078 69.5841 114.051 78.1316 110.646 85.1688C107.241 92.206 93.1377 124.637 93.1377 124.637",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.651 91.7563C107.651 91.7563 113.777 75.9467 120.982 78.4772C127.8 80.8872 125.28 89.5793 122.294 96.8013C119.307 104.023 108.609 131.666 108.609 131.666",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4102 99.4521C45.0399 99.4521 49.5397 101.533 52.0029 97.1867C53.7738 94.0617 53.3633 90.8323 50.3929 88.35",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9251 72.441C99.5256 69.6746 98.7975 66.2647 96.2988 64.825C93.8 63.3853 90.4769 64.4609 88.8764 67.2274C87.2759 69.9938 88.0041 73.4036 90.5029 74.8433C93.0016 76.283 96.3247 75.2075 97.9251 72.441Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.786 75.0354C114.387 72.2689 113.659 68.859 111.16 67.4193C108.661 65.9796 105.338 67.0553 103.738 69.8217C102.137 72.5882 102.865 75.9979 105.364 77.4376C107.863 78.8773 111.186 77.8018 112.786 75.0354Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.692 86.7952C125.292 84.0287 124.564 80.6188 122.065 79.1791C119.567 77.7394 116.243 78.8151 114.643 81.5815C113.043 84.348 113.771 87.7577 116.269 89.1974C118.768 90.6371 122.091 89.5616 123.692 86.7952Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.205 102.085C133.118 99.2231 131.761 96.236 129.172 95.4132C126.584 94.5904 123.745 96.2434 122.832 99.1054C121.918 101.967 123.276 104.954 125.864 105.777C128.452 106.6 131.291 104.947 132.205 102.085Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5946 143.684C28.5946 143.684 21.35 132.349 27.9105 115.567C34.4711 98.7854 36.7652 108.08 42.9071 82.9034C44.9679 74.4604 49.0492 73.151 52.4542 74.7416C55.8593 76.3322 56.777 82.6785 56.3182 88.575",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0469 94.4635C59.0469 94.4635 71.1216 72.6931 75.4121 64.5232C79.7026 56.3533 83.2847 47.0105 89.0483 47.9665C94.506 48.8743 95.8665 53.638 92.2682 63.8404",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8213 58.8193C93.8213 58.8193 97.798 46.8255 103.594 47.9341C109.39 49.0427 109.277 55.871 106.548 66.9892",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.691 61.125C107.691 61.125 110.911 54.4493 117.464 57.7189C122.914 60.4422 118.373 77.6817 118.373 77.6817",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119.403 72.4761C120.075 71.4262 121.05 70.6045 122.2 70.1197C123.35 69.6349 124.62 69.5097 125.843 69.7608C130.721 70.7811 131.076 76.9909 129.941 83.5943C128.806 90.1977 127.662 94.4795 127.662 94.4795",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.466 51.3643L126.326 25.0551L132.235 50.2316L169.739 35.2655L152.464 78.1315L190.877 82.6703L158.372 96.2788L179.511 124.179L143.601 117.824L148.149 138.012L124.282 128.26",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClapping);
export default __webpack_public_path__ + "static/media/clapping.8062d4f46543a496fd5045a5df4a6827.svg";
export { ForwardRef as ReactComponent };